<ion-toolbar mode="ios">
  <ion-title *ngIf="modalTitle">
    {{ modalTitle }}
  </ion-title>
  <ion-title *ngIf="!modalTitle">
    <span *ngFor="let modalTitle of modalTitles">
      {{ modalTitle }}
    </span>
  </ion-title>
  <ion-buttons slot="end">

    <ion-button
      *ngIf="showCloseButton"
      size="small"
      fill="clear"
      (click)="closeModal.emit()"
    >
      <ion-icon
        class="close-icon"
        slot="icon-only"
        src="./assets/icon/ic_close.svg"
      ></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
